import React from 'react'
import HeroSection from '../Components/conatct/hero'
import ContactSection from '../Components/conatct/contact'

const contact = () => {
  return (
    <div>
      <HeroSection/>
      <ContactSection/>
    </div>
  )
}

export default contact
